export const queryKeys = {
  users: "users",
  jobs: "jobs",
  companies: "companies",
  candidates: "candidates",
  categories: "categories",
  tags: "tags",
  cities: "cities",
  campaigns: "campaigns",
  campaignBudgets: "campaignBudgets",
};
